export default {
  maps: {
    pageTitle: 'ORS Mapy',
    Places: 'Místa',
    isochrones: 'Isochrony',
    placeNameRequired: 'Název místa vyžadován',
    altitude: 'Změny nadmořské výšky',
    settings: 'Nastavení',
    toggleAccessibleMode: 'Přepínání režimu přístupnosti',
    aboutTitle: 'O ORS',
    updateSearch: 'Prohledat tuto oblast',
    updateSearchAfterZoomOrCenterChange: 'Aktualizace vyhledávání po změně zvětšení nebo středu',
    pageNotFound: 'Stránka nebyla nalezena. Zkontrolujte, zda adresa URL není chybně vytvořena'
  }
}
